import React from 'react';
import { PaymentMethod } from '../../../../../../models/interfaces/PaymentMethod.interface';
import {
  CustomDataTableConfig,
  HeadCell,
} from '../../../../../../commons/components/custom-data-table/custom-data-table-config.model';
import CustomDataTableComponent from '../../../../../../commons/components/custom-data-table/custom-data-table.component';

interface UserPaymentMethodTableComponentProps {
  paymentMethods: PaymentMethod[];
  onSelect?: Function;
}

export default function UserPaymentMethodTableComponent(props: UserPaymentMethodTableComponentProps) {
  const headCells: HeadCell[] = [
    { id: 'id', field: 'id', label: 'ID' },
    { id: 'paymentMethodType', field: 'paymentMethodType', label: 'Type' },
    { id: 'last4', field: 'additionalProviderPaymentMethodData.last4', label: 'Last 4 numbers' },
    { id: 'isDefault', label: 'Default', getFieldValueFunc: (item: PaymentMethod) => (item.isDefault ? 'Yes' : 'No') },
    { id: 'createdAt', field: 'createdAt', label: 'Created at' },
    { id: 'lastUpdatedAt', field: 'lastUpdatedAt', label: 'Last updated at' },
  ];

  const tableConfig: CustomDataTableConfig = {
    tableName: 'Payment methods',
    rowsPerPage: 10,
    headCells,
    highlightRowColorFunc: (item: PaymentMethod): string | null => (item?.isDefault ? 'limegreen' : null),
  };

  return <CustomDataTableComponent tableConfig={tableConfig} data={props.paymentMethods} onSelect={props.onSelect} />;
}
